import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { CSpacing, NativeProps } from '@/src/components/interfaces';

export enum AlignItems {
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
}

export enum JustifyContent {
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
  Center = 'center',
  SpaceBetween = 'space-between',
  SpaceAround = 'space-around',
}

export enum FlexDirection {
  Row = 'row',
  RowReverse = 'row-reverse',
  Column = 'column',
  ColumnReverse = 'column-reverse',
}

export type CFlexElement = 'div' | 'aside' | 'section' | 'article' | 'main' | 'nav' | 'header' | 'footer';

export interface CFlexProps extends NativeProps {
  direction?: FlexDirection;
  alignItems?: AlignItems;
  justifyContent?: JustifyContent;
  fullWidth?: boolean;
  fullHeight?: boolean;
  gap?: CSpacing;
  rowGap?: CSpacing;
  columnGap?: CSpacing;
  as?: CFlexElement;
}

export function CFlex(props: PropsWithChildren<CFlexProps>): React.JSX.Element {
  const Tag = props.as ?? 'div';

  return (
    <Tag
      id={props.id}
      data-test-selector={props.testSelector}
      style={props.style}
      onClick={props.onClick}
      className={classNames('c-flex', {
        [`c-flex__direction--${props.direction}`]: props.direction !== undefined,
        [`c-flex__align-items--${props.alignItems}`]: props.alignItems !== undefined,
        [`c-flex__justify-content--${props.justifyContent}`]: props.justifyContent !== undefined,
        'c-flex--full-width': props.fullWidth,
        'c-flex--full-height': props.fullHeight,
        [`c-gap--${props.gap}`]: props.gap !== undefined,
        [`c-row-gap--${props.rowGap}`]: props.rowGap !== undefined,
        [`c-column-gap--${props.columnGap}`]: props.columnGap !== undefined,
        'cursor--pointer': props.onClick,
      }, props.class)}
    >
      {props.children}
    </Tag>
  );
}